<template>
  <b-modal @ok="triggerReport" class="pt-8" v-model="showModal" header-class="p-0"
    footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap" :title="modalTitle"
    no-close-on-backdrop :size="isMany ? undefined : 'sm'">
    <template #modal-title="{ cancel }">
      <div class="title-block text-center p-2">
        {{ title || $translate("select_report_type") }}
      </div>
      <div class="close-btn" @click="cancel()">×</div>
    </template>
    <template #default>
      <b-form class="mt-3">
        <div v-if="isMany">
          <b-row>
            <b-col cols="6" v-for="(item, idx) in reportList" :key="'reportList' + idx">
              <div class="form-check me-2">
                <label class="form-check-label ps-2">
                  <input :key="'reportTypeGroup' + idx" :value="item.value" type="radio" v-model="reportType"
                    class="form-check-input" name="DateRangeSelector" id="optionsRadios1" />
                  {{ item.label }}
                  <i class="input-helper"></i>
                </label>
              </div>
            </b-col>
          </b-row>
        </div>

        <div :class="{ 'text-center': isOne || isStatement }">
          <b-spinner v-if="isOne || isStatement" v-show="reportLoading" label="Spinning"></b-spinner>
          <b-link v-if="!!reportDataUrl" @click="loadReport">{{ $translate("click_to_download") }}</b-link>
          <b-link v-else-if="!!reportUrl" :href="reportUrl" target="_blank">{{$translate("click_to_download") }}</b-link>
        </div>
      </b-form>
    </template>

    <template #modal-footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button class="test-generate-report-ref" size="sm" :disabled="!reportType || reportLoading" variant="info" @click="ok()" v-if="isMany"
        ref="generateReportRef">
        <span>{{
    reportLoading
      ? $translate("generating_report")
      : $translate("generate_report")
  }}</span>
      </b-button>
      <b-button class="test-cancel-label" size="sm" variant="info" @click="cancel()">
        {{ $cancelLabel() }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import popupMixins from "@/mixins/popupMixins";
import permissionsMixins from "@/mixins/permissionsMixins";

export default {
  name: "reports-exportDetails",
  mixins: [popupMixins, permissionsMixins],
  data() {
    return {
      showModal: false,
      reportType: null,
      mediaType: null,
      fileName: null
    };
  },

  props: {
    reportList: {
      type: Array,
      default: () => [],
    },
    query: {
      type: Object,
      default: () => ({}),
    },
    getReportData: {
      type: Function,
    },
    orderId: { type: [Number, String] },
    statementType: { type: [String] },
    title: { type: [String] },
  },
  computed: {
    isMany() {
      return this.reportList && this.reportList.length > 1;
    },
    isOne() {
      return this.reportList && this.reportList.length === 1;
    },

    isStatement() {
      return !this.reportList || this.reportList.length === 0;
    },
    modalTitle() {
      return (
        this.title ||
        (this.isMany
          ? this.$translate("select_report_type")
          : this.$translate("report_generator"))
      );
    },
    reportUrl() {
      return this.$store.state.js_report.url;
    },
    reportDataUrl() {
      return this.$store.state.js_report.data_url;
    },
    reportLoading() {
      return this.$store.state.js_report.reportLoading;
    },
  },

  watch: {
    reportType: function () {
      this.clearUrl();
    },
    showModal: function (state) {
      this.reportType = null;
      this.clearUrl();
      if (state && this.isOne) {
        this.triggerReport();
      } else if (state && this.isStatement) {
        const { orderId: order_id, statementType: statement_type } = this;
        this.generateStatement({ order_id, statement_type });
      }
    },
  },
  methods: {
    getContentType(extension) {
      switch (extension) {
        case "html":
          return "text/html";
        case "pdf":
          return "application/pdf";
        case "xlsx":
          return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        default:
          throw new Error("Unknown Extension");
      }
    },
    show() {
      this.showModal = true;
    },
    close() {
      this.showModal = false;
    },

    clearUrl() {
      this.$store.commit("js_report/set_data_url");
      this.$store.commit("js_report/set_url");
    },

    loadReport() {
      const downloadLink = document.createElement("a");
      downloadLink.href = `data:${this.mediaType};base64,${this.reportDataUrl}`;
      downloadLink.download = this.fileName;
      downloadLink.click();
    },

    async triggerReport(evt) {
      evt && evt.preventDefault();
      console.log("trigger report");
      let reportObject;
      if (this.reportType == null && this.reportList.length == 1) {
        reportObject = this.reportList[0];
      } else {
        reportObject = this.reportList.find((x) => x.value == this.reportType);
      }
      if (!reportObject) {
        throw new Error(this.$translate("no_report_selected"));
      }
      console.log("report Object", reportObject);

      const { extension, name, template_id, value } = reportObject;
      const { query, getReportData } = this;

      const shortid = template_id || value;

      let data = null;
      if (getReportData && typeof getReportData == "function") {
        data = getReportData();
      }

      try {
        this.clearUrl();
        const statement_type = name;
        const fileName = `${name}.${extension}`;
        const mediaType = this.getContentType(extension);

        this.fileName = fileName;
        this.mediaType = mediaType;

        await this.$store.dispatch("js_report/lambdaDownload", {
          shortid,
          query,
          data,
          fileName,
          mediaType,
          statement_type
        });
      } catch (err) {
        console.log("err", err);
        this.doToast(this.$translate("error"), err.message, "danger");
      }
    },

    async generateStatement({ order_id, statement_type }) {
      try {
        console.log("generate statement");
        this.clearUrl();
        await this.$store.dispatch("js_report/downloadStatement", {
          order_id,
          statement_type,
        });
      } catch (err) {
        console.log("err", err);
        this.doToast(this.$translate("error"), err.message, "danger");
      }
    },
  },
};
</script>

<style scoped></style>
